import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit,
    Input,
    OnDestroy,
    TemplateRef,
    ViewEncapsulation,
    Renderer2
  } from "@angular/core";
  
  
  import { environment } from "../../../environments/environment";
  import { QuillEditorComponent } from "ngx-quill/src/quill-editor.component";
  import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";
  import { LoaderService } from "../../shared/loader-spinner/index";
  import { BsModalRef, BsModalService } from "ngx-bootstrap";
  import { SharedService } from "../../shared/services/shared.service";
  import { TranslateService } from "@ngx-translate/core";
  import * as QuillNamespace from "quill";
  
  import { EmailSmsDataService } from "../../shared/services/email-sms-data.service";
  import { EmailSmsSubject } from "../../shared/services/email-sms-subject";
  import { EmailSmsHelperUtils } from "../../shared/services/email-sms-helper";
  import { QuizHelperUtil } from "../../shared/services/QuizHelper.util";
  import { AppointmentsService } from "../../appointments/appointments.service";
  import { SlotsService } from "../slots.service";
  import { NotificationsService } from "angular2-notifications";
  import { SlotDataService } from "../slots-data.service";
  import { Router, ActivatedRoute } from "@angular/router";
  
  
  
  
  let Quill: any = QuillNamespace;
  
  declare var cloudinary: any;
  declare var $: any;
  
  @Component({
    selector: "app-confirmation-template-body",
    templateUrl: "./confirmation-sidebar.component.html",
    styleUrls: ["./confirmation-sidebar.component.css"],
    encapsulation: ViewEncapsulation.None
  })
  export class ConfirmationTemplateBodyComponent implements OnInit {
    @ViewChild(QuillEditorComponent)
    quill: QuillEditorComponent;
    CM_accepted_formats = ['image'];
    openSideBar;
    @Input()
    notificationType: any;
    appointmentdate;
    appointmenttime;
    public language: string;
  
    public variables = [];
    public buttonValues = [];
    public officeId;
    public templateId;
    public languageChange;
    public addEmailForm: FormGroup;
    public defaultTemplateSubscription;
    public getTemplateSubscription;
    public saveTemplateSubscription;
    public templateSubscription;
    public modalRef: BsModalRef;
    public imageORvideo;
    public currentLang = 'nl-NL';
    public imageURL;
    private isRecruiter : boolean = false;
    public body = {
      AppointmentCode: "",
      IsClient: true,
      Subject:"",
      Note: "",
      FilePath: [],
      SmsText: "",
      OfficeInfo: {},
      LeadUserInfo: {},
      SendMail:false
    }
    smsDefaultModules = {
      toolbar: [["showHtml"]]
    };
  
    smsOptions_en = [
      {
        groupName: "Client",
        options: [
          {
            name: "First Name : %fname%",
            value: "%fname%"
          },
          {
            name: "Last Name : %lname%",
            value: "%lname%"
          },
          {
            name: "Phone : %phone%",
            value: "%phone%"
          },
          {
            name: "Email : %email%",
            value: "%email%"
          },
          {
            name: "Lead Id : %leadid%",
            value: "%leadid%"
          }
        ]
      },
      {
        groupName: "Appointment",
        options: [
          {
            name: "Type : %atype%",
            value: "%atype%"
          },
          {
            name: "Duration : %duration%",
            value: "%duration%"
          },
          {
            name: "Date and Time : %datetime%",
            value: "%datetime%"
          },
          {
            name: "Office : %office%",
            value: "%office%"
          },
          {
            name: "Scheduling Link : %slink%",
            value: "%slink%"
          },
          {
            name: "Add to iCal/Outlook Calendar : %ical%",
            value: "%ical%"
          },
          {
            name: "Add to Google Calendar : %gcal%",
            value: "%gcal%"
          },
          {
            name: "Reschedule/Cancel Appointment : %rclink%",
            value: "%rclink%"
          },
          {
            name: "Source Name : %sourcename%",
            value: "%sourcename%"
          }
        ]
      }
    ];
  
    smsOptions_nl = [
      {
        groupName: "Client",
        options: [
          {
            name: "Voornaam : %fname%",
            value: "%fname%"
          },
          {
            name: "Achternaam : %lname%",
            value: "%lname%"
          },
          {
            name: "Telefoon : %phone%",
            value: "%phone%"
          },
          {
            name: "Email : %email%",
            value: "%email%"
          },
          {
            name: "Lead Id : %leadid%",
            value: "%leadid%"
          }
  
        ]
      },
      {
        groupName: "Appointment",
        options: [
          {
            name: "Type : %atype%",
            value: "%atype%"
          },
          {
            name: "Tijd : %duration%",
            value: "%duration%"
          },
          {
            name: "Datum en tijd : %datetime%",
            value: "%datetime%"
          },
          {
            name: "Kantoor : %office%",
            value: "%office%"
          },
          {
            name: "Scheduling Link : %slink%",
            value: "%slink%"
          },
          {
            name: "Toevoegen aan Ical / Outlook-agenda : %ical%",
            value: "%ical%"
          },
          {
            name: "Voeg toe aan Google Agenda : %gcal%",
            value: "%gcal%"
          },
          {
            name: "Plannen/Annuleren afspraak : %rclink%",
            value: "%rclink%"
          },
          {
            name: "Naam bron : %sourcename%",
            value: "%sourcename%"
          }
        ]
      }
    ];
    defaultModules = {
      toolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],
  
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        // [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        // [{ 'direction': 'rtl' }],                         // text direction
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["clean"], // remove formatting button
  
        ["link"],
        ["showHtml2"] // link and image, video
      ]
    };
  
    public isExternal;
    public externalLang;
    public isVisibleMediaLibrary:boolean=false;
    public shareTemplate;
  
  
    constructor(
      private translate: TranslateService,
      private renderer: Renderer2,
      private sharedService: SharedService,
      private helperUtil: EmailSmsHelperUtils,
      private _fb: FormBuilder,
      private route : ActivatedRoute,
      private appointmentsService: AppointmentsService,
      private emailSmsDataService: EmailSmsDataService,
      private emailSmsSubject: EmailSmsSubject,
      private loaderService: LoaderService,
      private modalService: BsModalService,
      private slotsService : SlotsService,
      private router: Router,
      private notificationsService : NotificationsService,
      public slotDataService: SlotDataService,
    ) {
      this.variables = this.helperUtil.VARIABLE_FIELD;
      this.buttonValues = this.helperUtil.BUTTON_FIELDS;
      this.isExternal = this.route.snapshot.queryParams["isExternal"];
      this.externalLang = this.route.snapshot.queryParams["lang"];
      this.makeQuillEditorToReplacePTagWithDiv();
    }
    languages = [{
      name: 'English',
      value: 'en-US'
    }, {
      name: 'Nederlands',
      value: 'nl-NL'
    }]
  
    /**
     * Quill Editor  by default supports p tag to wrap the content due to which extra margin is added when send to mail
     * We have replaced the default `p` tag with div tag so that the extra margin is removed
     */
    makeQuillEditorToReplacePTagWithDiv() {
      var Block = Quill.import("blots/block");
      Block.tagName = "DIV";
      Quill.register(Block, true);
    }
  
    ngOnInit() { 

    this.route.snapshot.queryParams.type == "1" ? this.isRecruiter = true : this.isRecruiter = false;
      this.officeId = this.appointmentsService.getOffice();
      // this.templateId = this.emailSmsDataService.getTemplateId();
  
  
    //   this.templateSubscription = this.emailSmsSubject
    //     .getTemplateId()
    //     .subscribe(id => {
    //       this.templateId = id;
    //       this.fetchTemplateBody();
    //     });
  
    //   this.languageChange = this.translate.currentLang;
  
    //   this.translate.onLangChange.subscribe(language => {
    //     this.languageChange = language.lang;
    //     this.changeSelector();
    //   });
    // this.createForm();
    this.languageChange = this.translate.currentLang;
    this.translate.onLangChange.subscribe(language => {
      this.languageChange = language.lang;
    });
    if(this.isExternal){
      if(this.externalLang == 1){
        this.language = "nl-NL";
      }else{
        this.language = "en-US";
      }
     }else{
      this.language = localStorage.getItem('language-slots');
     }
      // this.onlangChange(this.language == '')
      if(this.language == 'en-US' || this.language == 'nl-NL'){
        this.onlangChange(this.language);
        this.currentLang = this.language
      }else{
        this.onlangChange('nl-NL')
        this.currentLang = 'nl-NL'
      }
      this.createForm();
      this.fetchTemplateBody();
     
  
     }
  
     onlangChange(ln) {
      this.translate.use(ln);
      if(!this.isExternal){
        localStorage.setItem('language', ln);
        localStorage.setItem('language-slots', ln);
      }
      this.slotsService.setLanguage(ln)
    }
    openModalCancel(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template, { class: "modal-sm" });
    }


    omit_special_char(event) {
      var k;
      k = event.charCode;
      if(k == 45 || k == 95){
        return true;
      }
      if(k == 32){
        return false;
      }
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }
  
    onPaste(event: ClipboardEvent) {
      let clipboardData = event.clipboardData
      let pastedText = clipboardData.getData('text');
      pastedText = pastedText.replace(/ +/g, "");
      var last = pastedText.replace(/[^0-9a-zA-Z-_ ]/g,'')
      var first = this.addEmailForm.controls.EmailLinkVariable.value
      this.addEmailForm.controls.EmailLinkVariable.patchValue(first+last);
      event.preventDefault();
    }
  
  
  
    insertVariable() {
      var that = this;
      var en_str_reschedule = `<select id="dropdownnew" class="form-control myDropdown ql-size en_str2_re_class">
      <option value="">Insert Variable Field</option>
      <optgroup label="Client">
        <option value="%fname%" >First Name : %fname%</option>
        <option value="%lname%" >Last Name : %lname%</option>
        <option value="%phone%" >Phone : %phone%</option>
        <option value="%email%" >Email : %email%</option>
        <option value="%leadid%">Lead Id : %leadid%</option>
      </optgroup>
      <optgroup label="Appointment">
        <option value="%atype%" >Type : %atype%</option>
        <option value="%duration%" >Duration : %duration%</option>
        <option value="%datetime%" >Date and Time : %datetime%</option>
        <option value="%office%" >Office : %office%</option>
        <option value="%slink%" >Scheduling Link : %slink%</option>
        <option value="%ical%" >Add to iCal/Outlook Calendar : %ical%</option>
        <option value="%gcal%"this >Add to Google Calendar : %gcal%</option>
        <option value="%rclink%" >Reschedule/Cancel Appointment : %rclink%</option>
        <option value="%sourcename%" >Source Name : %sourcename%</option>      
      </optgroup>
      </select>`;
   
      var nl_str_reschedule = `<select id="dropdownnew2" class="form-control myDropdown ql-size nl_str2_re_class">
      <option value="">Insert Variable Veld</option>
      <optgroup label="Client">
        <option value="%fname%" >Voornaam : %fname%</option>
        <option value="%lname%" >Achternaam : %lname%</option>
        <option value="%phone%" >Telefoon : %phone%</option>
        <option value="%email%" >Email : %email%</option>
        <option value="%leadid%">Lead Id : %leadid%</option>
      </optgroup>
      <optgroup label="Appointment">
        <option value="%atype%" >Type : %atype%</option>
        <option value="%duration%" >Tijd : %duration%</option>
        <option value="%datetime%" >Datum en tijd : %datetime%</option>
        <option value="%office%" >Kantoor : %office%</option>
        <option value="%slink%" >Scheduling Link : %slink%</option>
        <option value="%ical%" >Toevoegen aan Ical / Outlook-agenda : %ical%</option>
        <option value="%gcal%" >Voeg toe aan Google Agenda : %gcal%</option>
        <option value="%rclink%" >Plannen/Annuleren afspraak : %rclink%</option>
        <option value="%sourcename%" >Naam Bron : %sourcename%</option>      
      </optgroup>
      </select>`;
  
      var customButton1 = document.querySelectorAll(".ql-showHtml2");
  if(customButton1.length >0)
  {
      if(this.languageChange == 'en-US')
      {
      
      customButton1[0].parentElement.insertAdjacentHTML("beforeend", en_str_reschedule);
      document
      .getElementsByClassName("en_str2_re_class")[0]
      .addEventListener("change", ($event)=> {
        
        $(".beta .ql-editor").focus();
        that.pasteHtmlAtCaret($event.target["value"]);
        $event.target["value"] = "";
      });
    }
    else if(this.languageChange == 'nl-NL')
    {
      customButton1[0].parentElement.insertAdjacentHTML("beforeend", nl_str_reschedule);
      document
          .getElementsByClassName("nl_str2_re_class")[0]
          .addEventListener("change",($event)=>{
            
            $(".beta .ql-editor").focus();
            that.pasteHtmlAtCaret($event.target["value"]);
            $event.target["value"] = "";
          });
    }
  }
  // customButton1[0].classList.add("hide");
  
    }
    
  
    // closeSidebar(){
    //   this.slotDataService.setSideBar(false);
    // }
  
    /**
     * When sms variable is selected
     */
    onSmsVariableSelect = (value)=> {
      var cursorPos = $("#sms-textarea1").prop("selectionStart");
      var v = $("#sms-textarea1").val();
      var textBefore = v.substring(0, cursorPos);
      var textAfter = v.substring(cursorPos, v.length);
      this.addEmailForm.controls.SMSText.patchValue(
        textBefore + value + textAfter
      );
      // $('#sms-textarea').val(textBefore + value + textAfter);
    }
    addCampaignNameText = ()=> {
      var cursorPos = $("#subject1").prop("selectionStart");
      var v = $("#subject1").val();
      var textBefore = v.substring(0, cursorPos);
      var textAfter = v.substring(cursorPos, v.length);
      this.addEmailForm.controls.Subject.patchValue(
        textBefore + "%sourcename%" + textAfter
      );
    }
  
    /**
     * Function to fetch template body
     */
    fetchTemplateBody() { 
      // if (!this.templateId) return;
      this.loaderService.show();
      var templateId;
      this.slotsService.getAppointmentSlots(1,this.slotDataService.getAppointmentCode(),1,"",true).subscribe(data=>{
        if(data && Object.keys(data).length>0){
          this.currentLang = 'nl-NL';
          if(data.Language){
            if(data.Language == 2){
              this.currentLang = 'en-US';
            }
          }
          this.onlangChange(this.currentLang);
        
          if(this.route.snapshot.url.length > 1){
          templateId = data.RescheduledNotificationTemplateId;
          }else{
            templateId = data.ConfirmationNotificationTemplateId;
          }
          if(data.BookingSlots && data.BookingSlots.length == 0 && data.BookingSlotsShiftwise && data.BookingSlotsShiftwise.length == 0){
            window.parent.postMessage({
              'message': 'success',
              'isSlotBook' : true
            }, "*");
          }
        }
        if(templateId){
        this.getTemplateSubscription = this.slotsService
        .getTemplateBodyWithValueById(templateId,this.slotDataService.getAppointmentCode(),true)
        .subscribe(
          data => {
            this.loaderService.hide();
            this.addEmailForm.patchValue({
              Id: data.Id,
              Note: data.Body,
              SMSText: data.SMSText,
              Subject: data.Subject,
              EmailLinkVariable : data.EmailLinkVariable == null ? '' : data.EmailLinkVariable
            });
  
          const control = <FormArray>this.addEmailForm.controls['TemplateAttachmentList'];
            for(let i = control.length-1; i >= 0; i--) 
              {
                control.removeAt(i)
              }
            data.TemplateAttachmentList.forEach((ele) => {
              (<FormArray>this.addEmailForm.get("TemplateAttachmentList")).push( 
                new FormGroup({
                  FileName: new FormControl(ele.FileName),
                  FileUrl: new FormControl(ele.FileUrl),
                  FileIdentifier: new FormControl(ele.FileIdentifier)
                })
              )
            })
          },
          error => {
            this.sharedService.getTranslatedNotification(25);
            this.loaderService.hide();
          }
        );
        }
        this.loaderService.hide();
      })
    }
  
    /**
     * Function to create form
     */
    private createForm() {
      this.addEmailForm = this._fb.group({
        Id: [this.templateId],
        OfficeId: [this.officeId],
        NotificationType: [this.notificationType],
        Subject: [""],
        EmailLinkVariable : new FormControl(""),
        Note: [""],
        SMSText: [""],
        QuizInTemplateList: new FormArray([]),
        TemplateAttachmentList: new FormArray([]),
        FilePath:new FormArray([])
        // AppointTypeList: ['']
      });
    }
    // onSubmit() {
    //   this.loaderService.show();
    //   this.saveTemplateSubscription = this.appointmentsService
    //     .saveTemplateBody(this.addEmailForm.value)
    //     .subscribe(
    //       data => {
    //         this.loaderService.hide();
    //         this.sharedService.getTranslatedNotification(20);
    //       },
    //       error => {
    //         this.loaderService.hide();
    //         this.sharedService.getTranslatedNotification(25);
    //       }
    //     );
    // }
  
      /**
     ** Callback when image is inserted using media widget
     * @param data : Data received from the Media widget
     */
    whenImageInsertedUsingMediaWidget(data,shareTemplate) {
      
      data.assets.forEach(asset => {
        let imageUrl = asset.derived ? asset.derived[0].secure_url : asset.secure_url;
        this.imageORvideo = QuizHelperUtil.getFileType(imageUrl);
        this.imageURL = `<img src="${imageUrl}">`;
        this.openImageModal(imageUrl, shareTemplate);
      });
    }
  
  
      /**
     * *Callback when image is inserted using upload widget
     * @param callbackObject { error: any, result : any}
     */
    whenImageInsertedUsingUploadWidget(callbackObject: { error: any, result: any },shareTemplate): void {
      
      let error = callbackObject.error;
      let result = callbackObject.result
  
      if (!error && result[0].url) {
        this.imageORvideo = QuizHelperUtil.getFileType(result[0].url);
        let url = QuizHelperUtil.applyCoorniateFacesInUrl(result[0].url, result[0].coordinates)
        this.imageURL = `<img src="${url}">`;
        this.openImageModal(url, shareTemplate);
      } else {
        console.log(
          "Error! Cloudinary upload widget error questionImage",
          error
        );
      }
  
    }
  
  
  
    pasteHtmlAtCaret(html) {
      var sel, range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
  
          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);
  
          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      }
    }
  
    smsDefaultTemplate() {
      this.loaderService.show();
      this.defaultTemplateSubscription = this.appointmentsService
        .getDefaultTemplate(this.notificationType)
        .subscribe(
          data => {
            this.loaderService.hide();
            this.addEmailForm.patchValue({
              Body: data.Body,
              SMSText: data.SMSText,
              Subject: data.Subject,
              QuizInTemplateList: data.QuizInTemplateList,
              TemplateAttachmentList:  data.TemplateAttachmentList
            });
          },
          error => {
            this.loaderService.hide();
          }
        );
    }
  
    onUseMedia(shareTemplate){
      this.shareTemplate = shareTemplate;
      this.isVisibleMediaLibrary=true;
    }
  
    changeUploadedImageUrl(event){
      this.isVisibleMediaLibrary=false;
      if(event.message == "success"){
        if (event.externalUrl) {
          var content = event.externalUrl.split(".");
          var contentType = content[content.length - 1];
          if (
            contentType === "jpg" ||
            contentType === "jpeg" ||
            contentType === "tiff" ||
            contentType === "jpg" ||
            contentType === "gif" ||
            contentType === "png" || 
            contentType === "svg" || 
            contentType === "" 
          ) {
            this.imageORvideo = "image";
          } else {
            this.imageORvideo = "video";
          }
        }
        if(this.imageORvideo == "image"){
          this.imageURL = `<img src="${event.externalUrl}">`;
          this.openImageModal(event.externalUrl, this.shareTemplate);
        }
      }
    }
  
    openImageModal(resultUrl, shareTemplate) {
      this.modalRef = this.modalService.show(shareTemplate);
    }
  
    
    
  
    /**
     * Modal Open for preview template
     * @param template: template reference (#preview)
     */
    openPreviewModal(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template, { class: "modal-lg" });
    }
  
    /**
     * Modal for Default Template
     * @param template: template reference(#defaultTemplate)
     */
    openDefaultTemplateModal(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template, { class: "modal-sm" });
    }
  
    /**
     * confirm Default template
     */
    confirmDefaultTemplate(): void {
      this.smsDefaultTemplate();
      this.modalRef.hide();
    }
  
    /**
     * Decline Default Template
     */
    declineDefaultTemplate(): void {
      this.modalRef.hide();
    }
  
    submit() {
      this.slotDataService.setDateTime(this.appointmentdate, this.appointmenttime);
      this.addEmailForm.value["bookingDate"] = this.appointmentdate;
      this.addEmailForm.value["bookingTime"] = this.appointmenttime;
      this.addEmailForm.value[
        "appointmentBookingCode"
      ] = this.slotDataService.getAppointmentCode();
      this.addEmailForm.value["sendMail"] = "true";
      this.addEmailForm.value["isClient"] = "false";
      this.addEmailForm.value[
        "leadUserInfo"
      ] = this.slotDataService.getLeadUserInfo();
      this.addEmailForm.value["userType"] = 1;
      this.addEmailForm.value["timezone"] = this.slotDataService.timezone;
       this.addEmailForm.value['emailLinkVariable']= this.addEmailForm.controls.EmailLinkVariable.value;
       this.addEmailForm.value.TemplateAttachmentList.forEach(element => {
        this.addEmailForm.value['FilePath'].push(this.pushData(element))
      });
      this.loaderService.show();
      this.slotsService.bookAppointment(this.addEmailForm.value, true).subscribe(
        data => {
          this.loaderService.hide();
          this.sharedService.getTranslatedNotification(10);

          let queryParamsToApply:any = {};
          queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
          queryParamsToApply["type"] =  this.isRecruiter ? 1 : 2;
          
          if(this.sharedService.isExternal && (this.sharedService.isExternal === true || this.sharedService.isExternal === "true")){
            queryParamsToApply["isExternal"] =  this.sharedService.isExternal;
            queryParamsToApply["lang"] =  this.sharedService.externalLang;
          }

          this.router.navigate(["slots/confirmed"], {
            queryParams: queryParamsToApply
          });
        },
        error => {
          this.loaderService.hide();
          this.sharedService.getTranslatedNotification(25);
          console.log(error);
        }
      );
    }   

    pushData(data){
      return {
        FileName: data.FileName,
        FileLink: data.FileUrl
      }
    }
   
    ngAfterViewInit() {
  
      this.insertVariable();
  
    }
   
  }
  


// WEBPACK FOOTER //
// ./src/app/slots/confimation-sideBar/confirmation-sidebar.component.ts